import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Subscription } from 'rxjs';
import { feedbackSubmit } from '../model/feedbackSubmit';
import { FeedbackService } from '../service/feedback.service';
import { TextService } from 'src/app/common/text.service';

@Component({
  selector: 'app-submit',
  templateUrl: './submit.component.html',
  styleUrls: ['./submit.component.css']
})
export class SubmitComponent implements OnInit, OnDestroy {
  @ViewChild('feedbackForm', { static: false })
  feedbackForm!: NgForm;
  @Input() responseId = '';
  isListloading = false;
  errorMessage!: string;
  isError = false;
  submitFeedbackSubscription?: Subscription;
  feedbackSubmitted = false;
  feedBackData: feedbackSubmit = {   
    comment: '',
    responseId:''
  }
  init:any;
  constructor(private readonly feedbackService: FeedbackService,private readonly Init:TextService) {
  }
    ngOnDestroy(): void {
      this.submitFeedbackSubscription?.unsubscribe();
    }

  ngOnInit(): void {
    this.init = this.Init.getEditorInit();
  }
  onSubmit() {
    this.feedBackData.comment = this.feedbackForm.value.comment;
    this.feedBackData.responseId = (this.responseId);
    this.submitFeedback(this.feedBackData);
  }

  submitFeedback(feedbackdata: feedbackSubmit) {
    this.isListloading = true;
    this.feedbackSubmitted = true;
    this.feedbackService.submitFeedback(feedbackdata).subscribe({
      next: () => {
        this.feedbackService.feedbackEmitter.next(feedbackdata);
        this.isListloading = false;
        this.feedbackForm.reset();
        this.feedBackData.comment = '';
        this.feedbackSubmitted = false;
      },
      error: (err) => { this.isError = true; this.errorMessage = err.error; this.feedbackSubmitted = false; },
      complete: () => { this.feedbackSubmitted = false; }
    });
  }
}
